export const slugify = (name) => {
  if (!name) return "shop";
  return name
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
};

export const generateShopSlug = (name, id) => {
  const slug = slugify(name);
  // Obfuscate the backend ID so it looks like a random hash instead of a MongoDB ID
  const encodedId = btoa(id).replace(/=/g, "");
  return `${slug}-${encodedId}`;
};

export const extractIdFromSlug = (slugOrId) => {
  if (!slugOrId) return "";

  // Handle AliExpress-style obfuscation (encodeId)
  if (slugOrId.includes("pvid=")) {
    try {
      const match = slugOrId.match(/pvid=([^&]+)/);
      if (match && match[1]) {
        return atob(match[1]);
      }
    } catch (e) {
      // fallback to continue
    }
  }

  // If the string is exactly 24 characters of hex, it's already a raw MongoDB ID
  if (/^[0-9a-fA-F]{24}$/.test(slugOrId)) {
    return slugOrId;
  }

  const parts = slugOrId.split("-");
  const encodedId = parts[parts.length - 1]; // The encoded ID is always the last part

  try {
    // Pad the string with '=' to make its length a multiple of 4 (if needed)
    let paddedEncodedId = encodedId;
    while (paddedEncodedId.length % 4 !== 0) {
      paddedEncodedId += "=";
    }
    return atob(paddedEncodedId);
  } catch (e) {
    return encodedId; // Fallback just in case
  }
};
